
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/claims",
      function () {
        return require("private-next-pages/de/claims.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/claims"])
      });
    }
  